import React, { FC } from 'react';
import { InfoHeader as Header, useDrawer } from '@whitesharx/starfall-frontend-core';
import { Icon, sounds } from '@whitesharx/starfall-frontend-ui-kit';
import { barsContainerStyles } from './styles.css';

export const BARS_ICON_ID = 'header-bars-icon';

const MenuButton = () => {
  const { openDrawer } = useDrawer();
  const onClick = () => {
    sounds.play('click');
    openDrawer();
  };
  return (
    <div id={BARS_ICON_ID} className={barsContainerStyles} onClick={onClick}>
      <Icon name="bars" size="18" color="white" />
    </div>
  );
};

const InfoHeader: FC = () => <Header rightSlot={<MenuButton />} />;

export default InfoHeader;
